<template>
    <div>
        <infinite-scroller-vertical @scrolledTillBottom="onReachScrollBottom">
            <v-list dense>
                <template v-for="(user) in items">
                    <user-list-item :userDetail="user" :key="user.id"></user-list-item>
                </template>
                <v-skeleton-loader v-if="searchLoading" type="list-item-avatar@5" class="mt-5"></v-skeleton-loader>
            </v-list>
            <div>
                
            </div>
        </infinite-scroller-vertical>
    </div>
</template>
<script>
import { CLEAR_SEARCH_LIST } from "@/store/mutations.type"
import userListItem from "@/components/list-item/list-item-user.vue"
import searchTabMixin from "@/mixins/mixin-search-tab"
export default {
    mixins: [searchTabMixin],
    components: {
        userListItem
    },

    data: () => ({}),

    created() {
        if (this.$route.query.key) {
            this.getSearchListProfile()
        }
    },

    methods: {

        onReachScrollBottom(val) {
            if (val && this.$route.query.key) {
                this.getSearchListProfile()
            }
        }
    },

    watch: {
        '$route.query.key'(val) {
            this.$store.commit(CLEAR_SEARCH_LIST)
            if (val) {
                this.getSearchListProfile()
            }
        }
    }
}
</script>